// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3qe7U","dot":"styles__dot___2Jo4_","fx":"styles__fx___2sbrO"};